export default {
  methods: {
    getHighlights() {
      return this.highlights || this.safeHighlights || [];
    },

    isPathHighlighted(frameIndex, currentPath) {
      const highlights = this.getHighlights();
      if (!highlights || !highlights.length) return false;

      return highlights.some((highlight) => {
        if (highlight.frame_index - 1 !== frameIndex) return false;
        if (!highlight.path || !highlight.path.length) return false;

        if (highlight.path.length !== currentPath.length) return false;

        return highlight.path.every((pathItem, pathIndex) => {
          return this.matchesPathItem(currentPath[pathIndex], pathItem);
        });
      });
    },

    shouldExpandForHighlight(frameIndex, currentPath) {
      const highlights = this.getHighlights();
      if (!highlights || !highlights.length) return false;

      return highlights.some((highlight) => {
        if (highlight.frame_index - 1 !== frameIndex) return false;
        if (!highlight.path || !highlight.path.length) return false;

        if (highlight.path.length <= currentPath.length) return false;

        return currentPath.every((currentField, index) => {
          const pathItem = highlight.path[index];
          return pathItem && this.matchesPathItem(currentField, pathItem);
        });
      });
    },

    isFrameHighlighted(frameIndex) {
      const highlights = this.getHighlights();
      if (!highlights) return false;

      return highlights.some((h) => h && h.frame_index - 1 === frameIndex);
    },

    matchesPathItem(currentField, pathItem) {
      if (pathItem.type === 'array_element') {
        return (
          currentField &&
          currentField.type === 'array_element' &&
          currentField.index === pathItem.index
        );
      }

      const currentName = currentField?.name || currentField;
      return pathItem.name === currentName;
    },

    isVariableHighlighted(frameIndex, variableName) {
      const highlights = this.getHighlights();
      if (!highlights || !highlights.length) return false;

      return highlights.some((highlight) => {
        if (!highlight) return false;
        if (highlight.frame_index - 1 !== frameIndex) return false;
        if (!highlight.path || !highlight.path.length) return false;

        const firstPath = highlight.path[0];
        return firstPath && firstPath.name === variableName;
      });
    },

    shouldFrameExpand(frameIndex) {
      const highlights = this.getHighlights();
      if (!highlights || !highlights.length) return false;

      return highlights.some((highlight) => {
        return highlight && highlight.frame_index - 1 === frameIndex;
      });
    },

    shouldTopLevelVariableExpand(frameIndex, variableName) {
      const highlights = this.getHighlights();
      if (!highlights || !highlights.length) return false;

      return highlights.some((highlight) => {
        if (!highlight) return false;
        if (highlight.frame_index - 1 !== frameIndex) return false;
        if (!highlight.path || !highlight.path.length) return false;

        const firstPath = highlight.path[0];
        return firstPath && this.matchesPathItem({ name: variableName }, firstPath);
      });
    },
  },
};
